import { LambdaError } from 'src/app/core/services/base/supabase.service';

/** `details.code` que o sign-contract-v2 devolve quando o prazo interno da geração vence (CPK-5212). */
export const SIGNATURE_TIMEOUT_CODE = 'SIGNATURE_TIMEOUT';

/** Chave i18n da mensagem mostrada ao cliente nesse caso. */
export const SIGNATURE_TIMEOUT_I18N_KEY = 'SignatureNotReceived';

/**
 * `details.code` que o sign-contract-v2 devolve quando outra conta com o mesmo CPF já tem contrato assinado
 * no caso (CPK-5402). Tentar de novo não resolve: o texto diz que a equipe vai revisar o cadastro.
 */
export const DUPLICATE_REGISTRATION_CODE = 'DUPLICATE_REGISTRATION';

/** Chave i18n da mensagem mostrada ao cliente nesse caso. */
export const DUPLICATE_REGISTRATION_I18N_KEY = 'SignatureBlockedDuplicateRegistration';

const SIGN_FALLBACK_MESSAGE = 'Erro ao assinar o documento. Por favor, tente novamente.';

type SignError = (LambdaError & { error?: { message?: string } }) | null | undefined;

/**
 * Mensagem para o erro de `SignedContractService.doSign`.
 *
 * O prazo vencido escolhe o texto pelo `details.code`, não pela mensagem do servidor, que é em
 * inglês e para log. Os demais erros seguem como antes: a mensagem do corpo da resposta, depois a
 * do próprio erro, depois o texto padrão. `error.error?.message` cobre quem ainda chegue como
 * HttpErrorResponse.
 */
export function signatureErrorMessage(error: unknown, translate: (key: string) => string): string {
  const err = error as SignError;

  if (err?.body?.details?.['code'] === SIGNATURE_TIMEOUT_CODE) {
    return translate(SIGNATURE_TIMEOUT_I18N_KEY);
  }
  if (err?.body?.details?.['code'] === DUPLICATE_REGISTRATION_CODE) {
    return translate(DUPLICATE_REGISTRATION_I18N_KEY);
  }

  return err?.body?.message || err?.error?.message || err?.message || SIGN_FALLBACK_MESSAGE;
}
